<script>
import Layout from "../../../layouts/main";
import Multiselect from "vue-multiselect";
import PerPage from "../../../../components/per-page.vue";
import Filters from "../../../../components/filters.vue";
import moment from "moment";
import {
  FETCH_NTUC_REPORTS,
  FETCH_NTUC_MID_CONFIGS,
} from "@/state/actions.type";

export default {
  components: {
    Layout,
    Multiselect,
    PerPage,
    Filters,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fromDate: "",
      toDate: "",
      sorting_data: {
        sort_by_key: "",
        order: "",
      },
      selectedTypeFilter: [],
      selectedMidFilter: [],
      typeOptions: [
        { key: "ntuc_cc_daily", text: "MPGS CC Recon" },
        { key: "ntuc_monthly_ccr", text: "MPGS Batch" },
      ],
      pollingTimer: null,
      showDetailDrawer: false,
      detailItem: null,
      fields: [
        { key: "generated_at", sortable: true, label: "Created At" },
        { key: "report_type", sortable: false, label: "Type" },
        { key: "file_name", sortable: false, label: "File Name" },
        { key: "account_id", sortable: false, label: "MID" },
        { key: "timeframe", sortable: false, label: "Timeframe" },
        { key: "status", sortable: false, label: "Status" },
        { key: "actions", label: "", stickyColumn: true },
      ],
    };
  },

  filters: {
    date(value) {
      return moment(value).format("DD MMM YYYY");
    },
    sgtDate(value) {
      if (!value) return "\u2014";
      return moment(value).utcOffset(8).format("DD MMM YYYY");
    },
    time(value) {
      return "at " + moment(value).format("hh:mm A");
    },
    datetime(value) {
      if (!value) return "\u2014";
      return moment(value).format("DD MMM YYYY, hh:mm A");
    },
  },

  computed: {
    reports() {
      return this.$store.state.ntucRecon.reports;
    },
    totalRows() {
      return this.$store.state.ntucRecon.reportTotal;
    },
    isFetching() {
      return this.$store.state.ntucRecon.isFetchingReports;
    },
    midConfigs() {
      return this.$store.state.ntucRecon.midConfigs;
    },
    hasPendingReports() {
      return this.reports.some((r) => r.status === "pending");
    },
  },

  watch: {
    hasPendingReports(val) {
      if (val) {
        this.startPolling();
      } else {
        this.stopPolling();
      }
    },
  },

  created() {
    this.fetchReports();
    this.$store.dispatch(`ntucRecon/${FETCH_NTUC_MID_CONFIGS}`);
  },

  beforeDestroy() {
    this.stopPolling();
  },

  methods: {
    fetchReports() {
      let filters = {
        report_type: ["ntuc_cc_daily", "ntuc_monthly_ccr"],
      };

      if (this.selectedTypeFilter.length > 0) {
        filters.report_type = this.selectedTypeFilter.map((t) => t.key);
      }

      if (this.selectedMidFilter.length > 0) {
        filters.account_id = this.selectedMidFilter.map((m) => m.mid);
      }

      let payload = {
        page: this.currentPage,
        pagesize: this.perPage,
        filters: filters,
        sorting_data: this.sorting_data,
      };

      if (this.fromDate) {
        payload.from_date = moment(this.fromDate, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      }

      if (this.toDate) {
        payload.to_date = moment(this.toDate, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        payload.to_date = moment().format("YYYY-MM-DDTHH:mm:ssZ");
      }

      this.$store.dispatch(`ntucRecon/${FETCH_NTUC_REPORTS}`, payload);
    },

    dateChanged(value) {
      this.fromDate = value[0];
      this.toDate = value[1];
      this.fetchReports();
    },

    toggleFilter() {
      this.$root.$emit("bv::toggle::collapse", "report-filter-collapse");
    },

    resetAdvanceFilters() {
      this.selectedTypeFilter = [];
      this.selectedMidFilter = [];
    },

    onPerPageChange() {
      this.currentPage = 1;
      this.fetchReports();
    },

    reportTypeName(type) {
      switch (type) {
        case "ntuc_cc_daily":
          return "MPGS CC Recon";
        case "ntuc_monthly_ccr":
          return "MPGS Batch";
        default:
          return type;
      }
    },

    formatTimeframe(fromDate) {
      if (!fromDate) return "\u2014";
      return moment(fromDate).utcOffset(8).format("MMMM, YYYY");
    },

    statusText(status) {
      switch (status) {
        case "completed":
          return "Completed";
        case "failed":
          return "Failed";
        case "pending":
          return "Generating...";
        default:
          return status;
      }
    },

    openDetail(item) {
      this.detailItem = item;
      this.showDetailDrawer = true;
    },

    closeDetail() {
      this.showDetailDrawer = false;
      this.detailItem = null;
    },

    sortTransactions(item) {
      this.sorting_data.sort_by_key = item.sortBy;
      if (item.sortDesc) {
        this.sorting_data.order = "DESC";
      } else {
        this.sorting_data.order = "ASC";
      }
      this.fetchReports();
    },

    downloadReport(item) {
      if (item.file_link) {
        window.open(item.file_link, "_blank");
      }
    },

    startPolling() {
      if (this.pollingTimer) return;
      this.pollingTimer = setInterval(() => {
        this.fetchReports();
      }, 5000);
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <filters class="mb-3" @date-change="dateChanged" @toggle-filter="toggleFilter" :hideFilter="false" />

    <b-collapse id="report-filter-collapse" accordion="ntuc-report-accordion" style="padding: 25px;" class="common-border bg-white mb-3">
      <div class="row">
        <div class="col-md-6 mb-4">
          <label>Report Type</label>
          <multiselect
            v-model="selectedTypeFilter"
            :options="typeOptions"
            :multiple="true"
            label="text"
            track-by="key"
            placeholder="Search Report Type"
            :searchable="true"
            :close-on-select="false"
          />
        </div>
        <div class="col-md-6 mb-4">
          <label>MID</label>
          <multiselect
            v-model="selectedMidFilter"
            :options="midConfigs"
            :multiple="true"
            :custom-label="(opt) => `${opt.mid} - ${opt.label}`"
            track-by="mid"
            placeholder="Search MID"
            :searchable="true"
            :close-on-select="false"
          />
        </div>
      </div>

      <div class="d-flex justify-content-between">
        <b-btn variant="link" @click="resetAdvanceFilters" class="text-chai font-16px">Clear Filters</b-btn>
        <div>
          <b-btn variant="white" @click="toggleFilter" class="mr-2 cancel">Cancel</b-btn>
          <b-btn variant="primary" @click="fetchReports(); toggleFilter();" class="btn-padding">Apply</b-btn>
        </div>
      </div>
    </b-collapse>

    <div v-if="selectedTypeFilter.length > 0 || selectedMidFilter.length > 0" class="d-flex flex-wrap mb-3" style="gap: 8px;">
      <div
        v-for="(type, index) in selectedTypeFilter"
        :key="'type-' + index"
        class="badge custom-status badge-soft-warning d-flex align-items-center"
        style="font-size: 13px; padding: 6px 10px; gap: 6px;"
      >
        {{ type.text }}
        <i class="mdi mdi-close cursor-pointer" @click="selectedTypeFilter.splice(index, 1); fetchReports();"></i>
      </div>
      <div
        v-for="(mid, index) in selectedMidFilter"
        :key="'mid-' + index"
        class="badge custom-status badge-soft-warning d-flex align-items-center"
        style="font-size: 13px; padding: 6px 10px; gap: 6px;"
      >
        {{ mid.mid }} - {{ mid.label }}
        <i class="mdi mdi-close cursor-pointer" @click="selectedMidFilter.splice(index, 1); fetchReports();"></i>
      </div>
      <b-btn variant="link" class="text-chai p-0" style="font-size: 13px;" @click="resetAdvanceFilters(); fetchReports();">Clear all</b-btn>
    </div>

    <div class="d-flex justify-content-between my-3">
      <div></div>
      <div class="d-flex" style="gap: 10px;">
        <router-link to="/reconciliation/ntuc/uploads" class="btn btn-white" style="height: 44px; border-radius: 12px; border: 1px solid #DCDAD5; padding: 13px 16px; font-size: 14px;">
          Back to Uploads
        </router-link>
        <router-link to="/reconciliation/ntuc/create" class="btn btn-primary btn-padding" style="height: 44px;">
          <i class="mdi mdi-plus mr-1"></i> Create Reconciliation
        </router-link>
      </div>
    </div>

    <b-table
      class="table-custom"
      :items="reports"
      :fields="fields"
      responsive="sm"
      sticky-header="50vh"
      show-empty
      :busy="isFetching"
      empty-text="No reports found"
      hover
      no-local-sorting
      @sort-changed="sortTransactions"
    >
      <template v-slot:head()="data">
        <span>
          {{ $t(data.label) }}
          <img v-show="data.field.sortable && sorting_data.sort_by_key !== data.column" class="ml-2" src="@/assets/images/arrow-3.svg" alt="sort_up">
          <img v-show="data.field.sortable && sorting_data.sort_by_key === data.column && sorting_data.order === 'ASC'" class="ml-2" src="@/assets/images/sort_asc.svg" alt="sort_asc">
          <img v-show="data.field.sortable && sorting_data.sort_by_key === data.column && sorting_data.order === 'DESC'" class="ml-2" src="@/assets/images/sort_desc.svg" alt="sort_desc">
        </span>
      </template>

      <template #table-busy>
        <b-spinner class="align-middle" :small="true"></b-spinner>
      </template>

      <template #cell(generated_at)="row">
        <p class="table-date">{{ row.value | date }}</p>
        <p class="table-time">{{ row.value | time }}</p>
      </template>

      <template #cell(report_type)="{ value }">
        {{ reportTypeName(value) }}
      </template>

      <template #cell(file_name)="{ value, item }">
        <span class="text-chai cursor-pointer" @click="openDetail(item)">
          {{ value }}
        </span>
      </template>

      <template #cell(timeframe)="{ item }">
        {{ formatTimeframe(item.from_date) }}
      </template>

      <template #cell(status)="{ value }">
        <div
          class="badge custom-status"
          :class="{
            'badge-soft-success': value === 'completed',
            'badge-soft-danger': value === 'failed',
            'badge-soft-secondary': value === 'pending',
          }"
        >
          <b-spinner
            v-if="value === 'pending'"
            small
            class="mr-1"
          ></b-spinner>
          {{ statusText(value) }}
        </div>
      </template>

      <template #cell(actions)="{ item }">
        <b-dropdown class="show_details" size="sm p-0" variant="white bg-transparent" dropleft>
          <template v-slot:button-content>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M7.5 14.25C7.5 15.075 8.175 15.75 9 15.75C9.825 15.75 10.5 15.075 10.5 14.25C10.5 13.425 9.825 12.75 9 12.75C8.175 12.75 7.5 13.425 7.5 14.25ZM7.5 3.75C7.5 4.575 8.175 5.25 9 5.25C9.825 5.25 10.5 4.575 10.5 3.75C10.5 2.925 9.825 2.25 9 2.25C8.175 2.25 7.5 2.925 7.5 3.75ZM7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5C8.175 7.5 7.5 8.175 7.5 9Z" stroke="black" stroke-opacity="0.3"/>
            </svg>
          </template>
          <b-dropdown-item-button @click="openDetail(item)">View Details</b-dropdown-item-button>
          <b-dropdown-item-button v-if="item.status === 'completed' && item.file_link" @click="downloadReport(item)">Download Report</b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <div class="d-flex justify-content-between">
      <per-page
        v-model="perPage"
        :currentPage="currentPage"
        :totalRows="totalRows"
        :tableRowsCount="reports.length"
        @input="onPerPageChange"
      />
      <b-pagination
        class="my-auto"
        v-model="currentPage"
        :current-page="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="fetchReports"
      ></b-pagination>
    </div>
    <!-- Detail Sidebar -->
    <div class="right-bar" :class="{ 'active': showDetailDrawer }">
      <div class="h-100 d-flex flex-column" style="overflow-y: auto;">
        <div style="padding: 25px;">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0" style="font-size: 16px; font-weight: 700;">Report Details</h5>
            <i class="mdi mdi-close cursor-pointer" style="font-size: 20px; opacity: 0.5;" @click="closeDetail"></i>
          </div>
        </div>
        <div class="border-sep"></div>

        <div v-if="detailItem" class="flex-grow-1" style="padding: 25px;">
          <div class="detail-row">
            <p class="detail-label">File Name</p>
            <p class="detail-value">{{ detailItem.file_name }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Report Type</p>
            <p class="detail-value">{{ reportTypeName(detailItem.report_type) }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Status</p>
            <p class="detail-value">
              <span
                class="badge custom-status"
                :class="{
                  'badge-soft-success': detailItem.status === 'completed',
                  'badge-soft-danger': detailItem.status === 'failed',
                  'badge-soft-secondary': detailItem.status === 'pending',
                }"
              >{{ statusText(detailItem.status) }}</span>
            </p>
          </div>
          <div class="detail-row">
            <p class="detail-label">MID</p>
            <p class="detail-value">{{ detailItem.account_id }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Generated At</p>
            <p class="detail-value">{{ detailItem.generated_at | datetime }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Timeframe</p>
            <p class="detail-value">{{ formatTimeframe(detailItem.from_date) }}</p>
          </div>
          <div v-if="detailItem.from_date" class="detail-row">
            <p class="detail-label">From</p>
            <p class="detail-value">{{ detailItem.from_date | sgtDate }}</p>
          </div>
          <div v-if="detailItem.to_date" class="detail-row">
            <p class="detail-label">To</p>
            <p class="detail-value">{{ detailItem.to_date | sgtDate }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Ref ID</p>
            <p class="detail-value" style="word-break: break-all;">{{ detailItem.ref_id }}</p>
          </div>

          <div v-if="detailItem.message && detailItem.status === 'failed'">
            <div class="border-sep my-3"></div>
            <p class="detail-label mb-2" style="font-weight: 700;">Error</p>
            <div class="common-border p-3" style="background: rgba(222, 53, 53, 0.05); border-color: rgba(222, 53, 53, 0.2) !important;">
              <p class="mb-0 text-danger" style="font-size: 13px; word-break: break-word;">{{ detailItem.message }}</p>
            </div>
          </div>
        </div>

        <div v-if="detailItem && detailItem.status === 'completed' && detailItem.file_link" class="mt-auto">
          <div class="border-sep"></div>
          <div class="d-flex justify-content-end" style="padding: 16px 25px; gap: 12px;">
            <b-btn variant="primary" class="btn-padding" @click="downloadReport(detailItem)">
              <i class="mdi mdi-download mr-1"></i> Download Report
            </b-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="rightbar-overlay" :class="{ 'active': showDetailDrawer }" @click="closeDetail"></div>
  </Layout>
</template>

<style scoped>
.right-bar {
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06);
  position: fixed;
  transition: all 200ms ease-out;
  width: 440px;
  z-index: 9998;
  right: -450px;
  top: 0;
  bottom: 0;
}
.right-bar.active {
  right: 0;
}
.rightbar-overlay {
  background-color: rgba(0, 0, 0, 0.55);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 9997;
  transition: all 0.2s ease-out;
}
.rightbar-overlay.active {
  display: block;
}
.border-sep {
  border-top: 1px solid #DCDAD5;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(220, 218, 213, 0.3);
}
.detail-label {
  margin: 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  flex-shrink: 0;
}
.detail-value {
  margin: 0;
  font-size: 14px;
  text-align: right;
  word-break: break-word;
}
@media (max-width: 575px) {
  .right-bar {
    width: 100%;
    right: -100%;
  }
}
</style>
